export default [
  {
    title: '2. Moyu',
    summary: `
Handicap Turnier in Berlin.
    `,
    url: 'https://shogi-berlin.de/shogi/moyu2023/',
    dateRange: ['2023/09/23'],
    location: 'Ziegelstraße 5, 10117 Berlin',
  },
  {
    title: 'ESC/WOSC 2023',
    summary: `
Die nächste Europäische Meisterschaft (WOSC/ESC) findet in Strasbourg (Frankreich) statt. Weitere Details werden folgen.
    `,
    url: 'https://fesashogi.eu/',
    dateRange: ['2023/7/27','2023/7/30'],
    location: 'Parc de l\'Orangerie, Strasbourg',
  },
  {
    title: '8.Mori Ogai Turnier in Berlin',
    summary: `
Das nächste Berliner Shogi Turnier, wird nächstes Jahr in Februar stattfinden.
    `,
    url: 'https://shogi-berlin.de/shogi/berlintournament2023',
    dateRange: ['2023/2/11'],
    location: 'Ziegelstraße 5, 10117 Berlin',
  },
  {
    title: '1. Moyu',
    summary: `
Handicap Turnier in Berlin.
    `,
    url: 'https://shogi-berlin.de/shogi/moyu2022/',
    dateRange: ['2022/09/24'],
    location: 'Ziegelstraße 5, 10117 Berlin',
  },
  {
    title: 'ESC/WOSC 2022 in Mannheim',
    summary: `
Die nächste Europäische Meisterschaft findet in Mannheim statt. Weitere Details werden folgen.
    `,
    url: 'https://www.shogideutschland.de/esc2022/',
    dateRange: ['2022/07/28','2022/07/31'],
    location: 'Rheinpromenade 21, 68163  Mannheim',
  },
  {
    title: '7.Mori Ogai Turnier in Berlin',
    summary: `
Das nächste Berliner Shogi Turnier, wird nächstes Jahr in Februar stattfinden.
    `,
    url: 'https://shogi-berlin.de/shogi/berlintournament2022',
    dateRange: ['2022/2/19'],
    location: 'Ziegelstraße 5, 10117 Berlin',
  },
  {
    title: 'ODM/DM 2021 in Berlin',
    summary: `
Täglich werden immer mehr Menschen hierzulande geimpft, auch das Reisen soll im Sommer wieder möglich sein.
Daher planen wir für dieses Jahr die Offene Deutsche Meisterschaft (ODM) in Berlin für den 18. und 19. September.

Bitte den Termin schon mal vormerken!
    `,
    dateRange: ['2021/09/18','2021/09/19'],
    location: 'Ziegelstraße 5, 10117 Berlin',
    url: 'http://shogideutschland.de/Turniere/ODM_2021A.html',
  },
  {
    title: 'Europäische Meisterschaft 2021 in Minsk',
    summary: `
Die ESC/WOSC findet in diesem Jahr in Minsk statt. (Wurde also vom letzten Jahr in diesem Jahr geschoben)

ANMERKUNG: Für die Einreise per Flugzeug direkt in Minsk wird kein Visum benötigt,
solange man keinen langen Aufenthalt plant. Bitte beachtet die Einreisebestimmungen, damit keine Quarantäne notwendig wird.
    `,
    dateRange: ['2021/08/19','2021/08/20','2021/08/21','2021/08/22'],
    location: 'vul. Storozhovskaya 15, Minsk',
    url: 'http://euro2020.shogi.by/en/',
  },
  {
    title: 'Europäische Meisterschaft 2020 in Minsk',
    summary: `
~~Aktuell stehen noch keine weiteren Informationen bereit.
Aber für die Plannung wird es schonmal erwähnt.

ANMERKUNG: Für die Einreise per Flugzeug direkt in Minsk wird kein Visum benötigt,
solange man keinen langen Aufenthalt plant.~~
    `,
    dateRange: ['2020/07/02','2020/07/03','2020/07/04','2020/07/05'],
    location: 'vul. Storozhovskaya 15, Minsk',
    url: 'http://www.shogi.net/fesa/index.php?mid=2',
  },
  {
    title: 'Deutsche Meisterschaft 2020 in Hamburg',
    summary: `
~~Hamburg hat den Zuschlag für die Austragung der Deutschen Meisterschaft erhalten.
Außerdem wird dieses Jahr wieder das Internationale Shogi Forum in Japan stattfinden, vom 23. bis 26. Oktober.
Der deutsche Vertreter wird voraussichtlich im Rahmen der Deutschen Meisterschaft als Qualifikationsturnier entschieden.
Voranmeldungen können bei Uwe getätigt werden. ("uwefrischmuth@gmx.de")~~
    `,
    dateRange: ['2020/04/18','2020/04/19'],
    location: 'Max-Brauer-Allee 60, 22765 Hamburg',
    url: 'https://www.facebook.com/events/2164846467148943/',
  },
  {
    title: '3. SESHIN Turnier in Prag',
    summary: `
~~Wer noch nicht in Prag war, sollte diese Gelegenheit nutzen.
Dieses Turnier sticht durch die besonders hohen Preise aus.

Zusätzlich lockt es jeden Spieler an daran Teilzunehmen,
denn mit der Teilnahme erhält man die Chance ein Flugticket nach Japan zu gewinnen.

Voranmeldungen können bei Iori getätigt werden. ("iori01010358@yahoo.co.jp")~~
    `,
    dateRange: ['2020/03/28','2020/03/29'],
    location: 'Skautský Institut, Staromestské nám. 1/4, 110 00 Staré Mesto, Prague, Czech Republic',
    url: 'https://www.facebook.com/events/391161431583510/',
  },
  {
    title: '6.Mori Ogai Turnier in Berlin',
    summary: `
Das nächste Berliner Shogi Turnier, wird nächstes Jahr in Februar stattfinden.
    `,
    content: `
  # 6. Mori Ogai Turnier ([de](6-MoriOgai.pdf)/[eng](6-MoriOgai(Eng).pdf))

Der Berliner Shogi Club lädt zum offenen Mori-Ogai-Turnier am Samstag, den **15. Februar 2020** ein.

Austragungsort ist die HumboldtInitiative der Universität, die uns ihre Räumlichkeiten in der [Ziegelstraße 5,
10117 Berlin-Mitte](/#/locations) zur Verfügung stellt. Damit findet das Turnier diesmal zentral in Berlin statt. Gleich um
die Ecke befindet sich der Friedrichstadt-Palast, Sehenswürdigkeiten wie  Brandenburger Tor und
Berliner Stadtschloß sind zu Fuß erreichbar

Der Spielort ist mit der S-Bahn wenige Stationen von Berlin Hbf entfernt und von den Haltestellen
Friedrichstraße oder Oranienburger Straße nur 5 Minuten entfernt. Bei Anreise mit dem Auto gibt es auf dem
Innenhof Parkmöglichkeiten (in begrenzter Zahl). Eine Anreise/Abreise am selben Tag ist dadurch problemlos möglich.
Mehrere Hotels und Hostels verschiedener Preisklassen (ab 28,- €) liegen in unmittelbarer Nähe zu Spielort,
so daß einer Besichtigung der Stadt am Sonntag (oder des Nachtlebens am Freitag) nichts im Wege steht.

**Startgeld:** 10,- Euro, ermäßigtes Startgeld 5,- Euro für nicht Erwerbstätige jeder Art

**Wertung:** Das Turnier wird bei der FESA zur ELO-Auswertung eingereicht.

**Paarung:** Schweizer System. Weiche Kriterien werden angewendet zur Vermeidung von Paarungen mit großem Unterschied
in der Spielstärke sowie Paarungen von Spielern aus derselben Stadt.

**Zeitplan:** 30 + 30s, 5 Runden

  <br>10:00 – 10:20 Registrierung
  <br>10:30 – 12:00 Runde 1
  <br>12:00 – 13:30 Runde 2
  <br>
  <br>13:30 - 14:30 Lunchtime
  <br>
  <br>14:30 – 16:00 Runde 3
  <br>16:00 – 17:30 Runde 4
  <br>17:30 – 19:00 Runde 5
  <br>
  <br>19:00 – Preisverleihung
  <br>19:30 – Dinner (Details später)

Eine Registrierung ist bis zum Beginn des Turniers möglich. Die Teilnahme kann aber nur bei rechtzeitiger
Voranmeldung garantiert werde. Zur besseren Planung wird um frühzeitige Anmeldung gebeten.

Registrierte Spiele:

  <p><div class="table--scroll">\n\n| Nummer | Name | Wertung | Rang | Land |
  | - | - | - | - | - |
  | 1 | Kei Ichiyanagi | 2116 | 4 Dan | Jpn |
  | 2 | Richard Rödel | 1878 | 2 Dan | Ger |
  | 3 | Fumihiro Watanabe | 1684 | 1 Kyu | Jpn |
  | 4 | Daniel Többens | 1584 | 1 Kyu | Ger |
  | 5 | Lukas Vylete | 1560 | 2 Kyu | Svk |
  | 6 | Ingo Köhler | 1292 | 5 Kyu | Ger |
  | 7 | Maria Zgrebnakova | 552 | 5 Kyu | Svk |
  | 8 | Michael Helbig | &nbsp; | &nbsp; | Ger |
  | 9 | Peter Schulz | &nbsp; | &nbsp; | Ger |</div></p>

  <p>Registrierung per E-Mail info@shogi-berlin.de</p>
    `,
    content_en: `
# 6. Mori Ogai Tournamen ([de](6-MoriOgai.pdf)/[eng](6-MoriOgai(Eng).pdf))

The Berlin Shogi Club invites to the open Mori Ogai tournament on **Saturday, February 15, 2020**

The venue is the Humboldt Initiative of the University, which provides us with its premises at
Ziegelstraße 3, 10117 Berlin-Mitte. This time, the tournament will take place centrally in Berlin.
Just around the corner is the Friedrichstadt-Palast, sights such as the Brandenburg Gate and
Berlin City Palace are within walking distance

The venue is a few stops from Berlin Hbf by S-Bahn and only 5 minutes from the stops
Friedrichstraße or Oranienburger Straße. If arriving by car, there are parking spaces in the courtyard
(in limited numbers). An arrival / departure on the same day is easily possible.
Several hotels and hostels in various price ranges (from 28, - €) are in close
proximity to the venue, so that nothing stands in the way of a visit to the city on Sunday
(or the nightlife on Friday).

**Entry fee:** 10, - Euro, reduced entry fee 5, - Euro for non-working people of all kinds

**Rating:** Das Turnier wird bei der FESA zur ELO-Auswertung eingereicht.

**Pairing:** Swiss system. Soft criteria are used to avoid pairings with a big difference
in playing strength and pairings of players from the same city

**Schedule:** 30 + 30s, 5 Rounds

  <br>10:00 – 10:20 Registratio
  <br>10:30 – 12:00 Round 1
  <br>12:00 – 13:30 Round 2
  <br>
  <br>13:30 - 14:30 Lunchtime
  <br>
  <br>14:30 – 16:00 Round 3
  <br>16:00 – 17:30 Round 4
  <br>17:30 – 19:00 Round 5
  <br>
  <br>19:00 – Prize giving
  <br>19:30 – Dinner (details later)

Registration is possible until the beginning of the tournament.
Participation can only be guaranteed if timely advance notification.For better planning, early registration is requested.

Registrated Player:

  <p><div class="table--scroll">\n\n| Number | Name | Rating | Rang | Country |
  | - | - | - | - | - |
  | 1 | Kei Ichiyanagi | 2116 | 4 Dan | Jpn |
  | 2 | Richard Rödel | 1878 | 2 Dan | Ger |
  | 3 | Fumihiro Watanabe | 1684 | 1 Kyu | Jpn |
  | 4 | Daniel Többens | 1584 | 1 Kyu | Ger |
  | 5 | Lukas Vylete | 1560 | 2 Kyu | Svk |
  | 6 | Ingo Köhler | 1292 | 5 Kyu | Ger |
  | 7 | Maria Zgrebnakova | 552 | 5 Kyu | Svk |
  | 8 | Michael Helbig | &nbsp; | &nbsp; | Ger |
  | 9 | Peter Schulz | &nbsp; | &nbsp; | Ger |</div></p>

  <p>Registration by E-Mail info@shogi-berlin.de</p>
    `,
    dateRange: ['2020/2/15'],
    location: 'Ziegelstraße 5, 10117 Berlin',
  },
  {
    title: 'Fumihiro präsentiert',
    summary: `
An diesem Donnerstag wird Fumihiro uns etwas vorstellen ab ca. 19:30.
    `,
    dateRange: ['2020/1/23'],
    location: 'Ziegelstraße 5, 10117 Berlin',
    url: 'https://shogi-berlin.de/shogi/internalgames2020',
  },
  {
    title: 'Hausliga 2020 Round 1',
    summary: `
Die Hausliga im Januar wird am Donnerstag den 16.01 ab 18 Uhr statt finden.
    `,
    dateRange: ['2020/1/16'],
    location: 'Ziegelstraße 5, 10117 Berlin',
    url: 'https://shogi-berlin.de/shogi/internalgames2020',
  },
  {
    title: '11. Kurpfälzer Neujahrs Open',
    summary: `
Auch 2020 beginnt das Jahr wieder mit dem Neujahrsturnier, das traditionell am ersten Samstag nach Neujahr, also am 4. Januar 2020, in Ludwigshafen stattfindet. Anmeldung ist ab sofort möglich
    `,
    dateRange: ['2020/01/4'],
    location: 'Mundenheimer Straße 220, 67059 Ludwigshafen',
    url: 'https://shoginet.de/ausschreibung/neujahrs-open-2020/',
  },
  {
    title: 'Kyu Cup Hamburg',
    summary: `
Der diesjährige Kyu Cup in Hamburg ist wahrscheinlich für den 9. November geplant. Eine Ausschreibung folgt in Kürze.
    `,
    dateRange: ['2019/11/9'],
    location: 'Hamburg',
    url: 'http://www.shogihamburg.bplaced.net/',
  },
  {
    title: 'Frankfurt Ginkgo Open 2019',
    summary: `
Der Frankfurt Shogi Club lädt ein zu einem zweitägigen Turnier mit sieben Runden.
    `,
    dateRange: ['2019/10/12', '2019/10/13'],
    location: 'Idsteiner Str.91, 60326 Frankfurt',
    url: 'http://www.shogideutschland.de/Turniere/Frankfurt_2019.html',
  },
  {
    title: 'Europäische Meisterschaft (ESC/WOSC) 2019',
    summary: `
Die diesjährige Europameisterschaft findet in Bratislava statt.
    `,
    dateRange: ['2019/8/15', '2019/8/18'],
    location: 'Kralovske udolie 6, Bratislava, Slovakia',
    url: 'https://www.shogi2019.eu/',
  },
  {
    title: 'Europäische Jugendmeisterschaft (EYSC 2019)',
    summary: `
Die nächste europäische Jugendmeisterschaft (U18) findet in diesem Jahr wieder in Wroclaw statt.
    `,
    dateRange: ['2019/6/28', '2019/6/30'],
    location: 'Wybrzeze Wyspianskiego Street 23/25, 50-370 Wroclaw, Poland',
    url: 'http://www.shogi.wroclaw.pl/eysc-2019',
  },
  {
    title: 'Berlin Turnier',
    summary: `
Das nächste Berliner Shogi Turnier, wird nächstes Jahr in Februar stattfinden.
    `,
    dateRange: ['2019/2/23'],
    location: 'Ziegelstraße 5, 10117 Berlin',
    url: 'https://shogi-berlin.de#/shogi/berlintournament2019',
  },
  {
    title: 'Kyu Cup Hamburg',
    summary: `
  Der diesjährige Kyu Cup in Hamburg ist für den 3. November geplant. Eine Ausschreibung folgt in Kürze.
    `,
    dateRange: ['2018/11/3'],
    location: 'Hamburg',
    url: 'https://shogi-berlin.de#/shogi/berlintournament2019',
  },
  {
    title: 'Europäische Meisterschaft (ESC/WOSC)',
    summary: `
Das größe Turnier in Europa, die Europäische Meisterschaft, findet nach 7 Jahren,
wieder in Deutschland statt. Es wird mit mehr als 100 Teilnehmer gerechnet.
Aktuell sind 58 Leute registriert.
    `,
    dateRange: ['2018/7/26', '2018/7/29'],
    location: 'Saargemünder Str. 2, 14195 Berlin',
    url: 'https://www.shogi2018.eu/deutsch/',
  },
  {
    title: 'Präsentation Shogi beim Sommerfest',
    summary: `
Findet das Sommerfest der Deutsch-Japanischen Gesellschaft statt.
Dort werden wir mit einem Shogi-Stand vertreten sein. Es wird Shogi sowie Dobutsu-Shogi angeboten.
    `,
    dateRange: ['2018/6/30 15:00:00', '2018/6/30 19:00:00'],
    location: 'Goethestraße 49, 14163 Berlin',
    url: 'http://www.djg-berlin.de/events/sommerfest-der-djg-berlin/',
  },
  {
    title: 'Europäische Jugendmeisterschaft (EYSC 2018)',
    summary: `
Zum 2. mal findet die Europäische Shogimeisterschaft für junge Leute (U18) in Breslau statt.
    `,
    dateRange: ['2018/6/29', '2018/7/1'],
    location: 'Breslau (Wroclaw)',
    url: 'http://www.shogi.wroclaw.pl/eysc-2018',
  },
  {
    title: 'Shogi Turnier Prag',
    summary: `
8 Runden mit 35min + 30s Byoyomi Registrierung beginnt um 10 Uhr und
endet am Sonntag nach der Preisverleihung um 15:15
    `,
    dateRange: ['2018/6/2', '2018/6/3'],
    location: 'Prag',
    url: 'http://shogihub.com/events/122',
  },
];
